/**
 * To like the job from candidate
 * Access role allowed - Client/Candidate
 * @param data: object
 */
export const likeJob = (id, data) => async (dispatch, getState, api) => {
  try {
    await api.post(`candidates/job/${id}/like`, { data });
    return true;
  } catch (error) {
    return false;
  }
};
